module.exports = __webpack_public_path__ + "img/android-large-overlay.271ecfa8.png";